import React, { useState } from "react";
import { useReviewLibrary } from "../../hooks/useAssessmentTemplates";
import { Button, Field, Alert, Modal } from "../../components";
import "./Reviews.css";

// Pull more items into a category from the library.
//
// Anything already anywhere in this assessment is excluded, not just from this category:
// a review must not ask the same question twice, and the comparison between two reviews
// matches items by name, so duplicates would make two rows indistinguishable.
const AddItemsModal = ({ category, usedLibraryIds, onClose, onAdd }) => {
  const { items, loading } = useReviewLibrary();
  const [picked, setPicked] = useState([]);
  const [search, setSearch] = useState("");
  const [busy, setBusy] = useState(false);

  const available = items
    .filter((i) => i.enabled && !usedLibraryIds.includes(i.id))
    .filter((i) => !search || i.name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      const am = a.categories.includes(category.name) ? 0 : 1;
      const bm = b.categories.includes(category.name) ? 0 : 1;
      return am - bm || a.name.localeCompare(b.name);
    });

  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));

  const submit = async () => {
    setBusy(true);
    const ok = await onAdd(category.id, picked);
    setBusy(false);
    if (ok) onClose();
  };

  return (
    <Modal wide title={`Add items to ${category.name}`} onClose={onClose}
      footer={<>
        <span className="v2-hint" style={{ marginRight: "auto" }}>{picked.length} selected</span>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="primary" disabled={busy || picked.length === 0} onClick={submit}>
          {busy ? "Adding…" : `Add ${picked.length || ""}`}
        </Button>
      </>}>
      <Field label="Search the library">
        <input className="v2-input" value={search} placeholder="Backup restore testing"
               onChange={(e) => setSearch(e.target.value)} />
      </Field>

      {loading ? <p className="v2-hint">Loading…</p>
        : available.length === 0 ? (
          <Alert tone="warning">
            {items.length === 0
              ? "The item library is empty. Add items under Assessment templates first."
              : "Every enabled library item is already somewhere in this assessment."}
          </Alert>
        ) : (
          <div className="v2-picklist">
            {available.map((i) => (
              <button key={i.id} type="button"
                      className={`v2-pick${picked.includes(i.id) ? " on" : ""}`}
                      aria-pressed={picked.includes(i.id)}
                      onClick={() => toggle(i.id)}>
                <span className={`v2-check${picked.includes(i.id) ? " on" : ""}`} aria-hidden="true" />
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span className="v2-slot-name">{i.name}</span>
                  <span className="v2-slot-meta">
                    {i.categories.join(", ") || "No category"} · importance {i.default_weight}/5
                  </span>
                </span>
              </button>
            ))}
          </div>
        )}
    </Modal>
  );
};

export default AddItemsModal;
